export default function Team() {
  return (
    <section className="py-32 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-20">
          <p className="text-teal-600 font-medium text-sm tracking-wider uppercase mb-4">Our Team</p>
          <h2 className="text-5xl lg:text-6xl font-light text-gray-900 mb-6">
            함께 만들어가는 사람들
          </h2>
          <p className="text-xl text-gray-600 font-light max-w-3xl mx-auto">
            더 나은 물, 더 나은 세상을 믿는 팀
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {/* Team Member 1 */}
          <div className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition-all hover:-translate-y-2 duration-300">
            <div className="w-full h-80">
              <img 
                src="https://static.readdy.ai/image/c35fb388e939118942ecbf693c1f9da9/8d5fe04fb0fe565cd91cc273a659f9c9.jpeg"
                alt="Team Member"
                className="w-full h-full object-cover object-top grayscale"
              />
            </div>
            <div className="p-8 text-center">
              <h3 className="text-2xl font-medium text-gray-900 mb-2">정수연</h3>
              <p className="text-teal-600 font-medium mb-4">Founder & CEO</p>
              <p className="text-sm text-gray-600 font-light leading-relaxed">
                "좋은 물이란 무엇인가?"라는 질문으로 Heritage Water를 시작했습니다.
              </p>
            </div>
          </div>

          {/* Team Member 2 */}
          <div className="bg-white rounded-3xl shadow-lg overflow-hidden hover:shadow-2xl transition-all hover:-translate-y-2 duration-300">
            <div className="w-full h-80">
              <img 
                src="https://static.readdy.ai/image/c35fb388e939118942ecbf693c1f9da9/bc7ab10f24950f04aa262f78393aa7f4.jpeg"
                alt="Team Member"
                className="w-full h-full object-cover object-top grayscale"
              />
            </div>
            <div className="p-8 text-center">
              <h3 className="text-2xl font-medium text-gray-900 mb-2">이태훈</h3>
              <p className="text-teal-600 font-medium mb-4">Head of Marketing</p>
              <p className="text-sm text-gray-600 font-light leading-relaxed">
                브랜드의 가치를 세상에 전하는 것이 저의 역할입니다.
              </p>
            </div>
          </div>
        </div>

        {/* Join Us Section */}
        <div className="mt-20 bg-gradient-to-br from-teal-50 to-white rounded-3xl shadow-xl p-16 text-center border border-teal-100">
          <h3 className="text-3xl font-light text-gray-900 mb-6">함께 하시겠습니까?</h3>
          <p className="text-lg text-gray-600 font-light mb-8 max-w-2xl mx-auto leading-relaxed">
            Heritage Water는 더 나은 물, 더 나은 세상을 만들어갈 동료를 찾고 있습니다.<br />
            우리의 가치에 공감하신다면 언제든 연락주세요.
          </p>
          <button className="px-8 py-4 bg-teal-600 text-white rounded-full font-medium hover:bg-teal-700 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer">
            Join Our Team
          </button>
        </div>
      </div>
    </section>
  );
}